import type {
  Patient,
  ToothBrushHairType,
  ToothBrushType,
} from "@/types/api/patient";
import type { User } from "@/types/api/user";

import type { MouthType, Sector } from "./treatment";

export type ConsultationStep =
  | "CONSULTATION"
  | "SUMMARY"
  | "DESCALING"
  | "DEBRIDEMENT"
  | "SANITATION"
  | "REASSESSMENT"
  | "SURGERY"
  | "CONTROL";

export const ConsultationSteps = [
  "CONSULTATION",
  "SUMMARY",
  "DESCALING",
  "DEBRIDEMENT",
  "SANITATION",
  "REASSESSMENT",
  "SURGERY",
  "CONTROL",
] as const;

export const consultationStepsOptions: Array<{
  value: ConsultationStep;
  label: string;
}> = [
  { value: "CONSULTATION", label: "Consultation" },
  { value: "SUMMARY", label: "Bilan" },
  { value: "DESCALING", label: "Détartrage" },
  { value: "DEBRIDEMENT", label: "Débridement" },
  { value: "SANITATION", label: "Assainissement" },
  { value: "REASSESSMENT", label: "Réévaluation" },
  { value: "SURGERY", label: "Chirurgie" },
  { value: "CONTROL", label: "Contrôle" },
];

export const getConsultationStepLabel = (
  consultationStep: ConsultationStep
) => {
  return (
    consultationStepsOptions.find((step) => step.value === consultationStep)
      ?.label ?? ""
  );
};

export type Consultation = {
  id: number;
  doctor: User;
  doctorId: number;
  patient: Patient;
  patientId: number;
  consultationStep: ConsultationStep;
  comment?: string;
  toothbrushTypes: Array<ToothBrushType>;
  toothbrushHairTypes: Array<ToothBrushHairType>;
  toothbrushBrand: string | null;
  brushesDimensions: string | null;
  brushesBrand: string | null;
  sectors: Array<Sector>;
  mouthParts: Array<MouthType>;
  startDate: string;
  endDate: string;
  createdAt: string;
  updatedAt: string;
};
